import dynamic from 'next/dynamic';
import React, { type ComponentType, type HTMLProps } from 'react';

import { CardBrand } from '../__generated-gql-types__/globalTypes';

const Achievements = dynamic(() => import('../assets/svgs/achievements.svg'));
const Amex = dynamic(() => import('../assets/svgs/amex.svg'));
const AppleIcon = dynamic(() => import('../assets/svgs/apple-icon.svg'));
const Applicants = dynamic(() => import('../assets/svgs/applicants.svg'));
const Application = dynamic(() => import('../assets/svgs/application.svg'));
const ApplicationEdit = dynamic(() => import('../assets/svgs/casper-test.svg'));
const ApplySuccess = dynamic(() => import('../assets/svgs/apply-success.svg'));
const Arrow = dynamic(() => import('../assets/svgs/arrow.svg'));
const ArrowRight = dynamic(() => import('../assets/svgs/arrow-right.svg'));
const Badge = dynamic(() => import('../assets/svgs/badge.svg'));
const Bell = dynamic(() => import('../assets/svgs/bell.svg'));
const Brainstorming = dynamic(() => import('../assets/svgs/brainstorming.svg'));
const Calendar = dynamic(() => import('../assets/svgs/calendar.svg'));
const CasperTest = dynamic(() => import('../assets/svgs/achievements.svg'));
const CertificateCheckmark = dynamic(
  () => import('../assets/svgs/certificate-checkmark.svg'),
);
const Chat = dynamic(() => import('../assets/svgs/chat.svg'));
const ChatIllustration = dynamic(
  import('../assets/svgs/chat-illustration.svg'),
);
const Check = dynamic(() => import('../assets/svgs/check.svg'));
const CheckCircle = dynamic(() => import('../assets/svgs/check-circle.svg'));
const CheckCircleGreen = dynamic(
  () => import('../assets/svgs/check-circle-green.svg'),
);
const Chevron = dynamic(() => import('../assets/svgs/chevron.svg'));
const ChevronBack = dynamic(() => import('../assets/svgs/chevron-back.svg'));
const ChevronDouble = dynamic(
  () => import('../assets/svgs/chevron-double.svg'),
);
const Clock = dynamic(() => import('../assets/svgs/clock.svg'));
const ClockAlt = dynamic(() => import('../assets/svgs/clock-alt.svg'));
const Copy = dynamic(() => import('../assets/svgs/copy.svg'));
const Credit = dynamic(() => import('../assets/svgs/credit.svg'));
const CustomPackage = dynamic(
  () => import('../assets/svgs/custom-package.svg'),
);
const Dashboard = dynamic(() => import('../assets/svgs/dashboard.svg'));
const DealExecution = dynamic(
  () => import('../assets/svgs/deal-execution.svg'),
);
const Diners = dynamic(() => import('../assets/svgs/diners.svg'));
const Ding = dynamic(() => import('../assets/svgs/ding.svg'));
const Discover = dynamic(() => import('../assets/svgs/discover.svg'));
const DueDiligence = dynamic(() => import('../assets/svgs/due-diligence.svg'));
const Earth = dynamic(() => import('../assets/svgs/earth.svg'));
const Editing = dynamic(() => import('../assets/svgs/editing.svg'));
const Email = dynamic(() => import('../assets/svgs/email.svg'));
const EmployeeBadge = dynamic(
  () => import('../assets/svgs/employee-badge.svg'),
);
const English = dynamic(() => import('../assets/svgs/english.svg'));
const ErrorCircle = dynamic(() => import('../assets/svgs/error-circle.svg'));
const ErrorIcon = dynamic(() => import('../assets/svgs/error.svg'));
const Essay = dynamic(() => import('../assets/svgs/essay.svg'));
const Execution = dynamic(() => import('../assets/svgs/execution.svg'));
const Expand = dynamic(() => import('../assets/svgs/expand.svg'));
const Experiences = dynamic(() => import('../assets/svgs/experiences.svg'));
const Facebook = dynamic(() => import('../assets/svgs/facebook.svg'));
const Filter = dynamic(() => import('../assets/svgs/filter.svg'));
const FinancialModeling = dynamic(
  () => import('../assets/svgs/financial-modeling.svg'),
);
const Frameworks = dynamic(() => import('../assets/svgs/frameworks.svg'));
const Gift = dynamic(() => import('../assets/svgs/gift.svg'));
const Globe = dynamic(() => import('../assets/svgs/globe.svg'));
const Gmat = dynamic(() => import('../assets/svgs/GMAT.svg'));
const Google = dynamic(() => import('../assets/svgs/google.svg'));
const GraduateHat = dynamic(() => import('../assets/svgs/graduate-hat.svg'));
const Gre = dynamic(() => import('../assets/svgs/GRE.svg'));
const GroupClasses = dynamic(() => import('../assets/svgs/group-classes.svg'));
const Hamburger = dynamic(() => import('../assets/svgs/hamburger.svg'));
const Help = dynamic(() => import('../assets/svgs/help.svg'));
const Image = dynamic(() => import('../assets/svgs/image.svg'));
const Inbox = dynamic(() => import('../assets/svgs/inbox.svg'));
const InfluenceAndCollaboration = dynamic(
  () => import('../assets/svgs/influence-and-collaboration.svg'),
);
const InfoCircle = dynamic(() => import('../assets/svgs/info-circle.svg'));
const InfoFilled = dynamic(() => import('../assets/svgs/info-filled.svg'));
const Instagram = dynamic(() => import('../assets/svgs/instagram.svg'));
const IntegratedReasoning = dynamic(
  () => import('../assets/svgs/integrated-reasoning.svg'),
);
const Interview = dynamic(() => import('../assets/svgs/interview.svg'));
const JCB = dynamic(() => import('../assets/svgs/jcb.svg'));
const Leland = dynamic(() => import('../assets/svgs/leland.svg'));
const LelandCompass = dynamic(
  () => import('../assets/svgs/leland-compass.svg'),
);
const LelandLogo = dynamic(() => import('../assets/svgs/leland-logo.svg'));
const LettersOfEvaluation = dynamic(
  () => import('../assets/svgs/letters-of-evaluation.svg'),
);
const Lightning = dynamic(() => import('../assets/svgs/lightning.svg'));
const Link = dynamic(() => import('../assets/svgs/link.svg'));
const LinkExternal = dynamic(() => import('../assets/svgs/link-external.svg'));
const LinkedIn = dynamic(() => import('../assets/svgs/linkedin.svg'));
const LinkedInReview = dynamic(
  () => import('../assets/svgs/linkedin-review.svg'),
);
const LinkedInSquare = dynamic(
  () => import('../assets/svgs/linkedin-square.svg'),
);
const Loader = dynamic(() => import('../assets/svgs/loader.svg'));
const Location = dynamic(() => import('../assets/svgs/location.svg'));
const Lock = dynamic(() => import('../assets/svgs/lock.svg'));
const MasterCard = dynamic(() => import('../assets/svgs/mastercard.svg'));
const Math = dynamic(() => import('../assets/svgs/math.svg'));
const MdPhDEssay = dynamic(() => import('../assets/svgs/md-phd-essay.svg'));
const Menu = dynamic(() => import('../assets/svgs/menu.svg'));
const Message = dynamic(() => import('../assets/svgs/message.svg'));
const MessageAlt = dynamic(() => import('../assets/svgs/message-alt.svg'));
const MessageUnread = dynamic(
  () => import('../assets/svgs/message-unread.svg'),
);
const Networking = dynamic(() => import('../assets/svgs/networking.svg'));
const Notifications = dynamic(() => import('../assets/svgs/notifications.svg'));
const QuestionIllustration = dynamic(
  () => import('../assets/svgs/question-illustration.svg'),
);
const Package = dynamic(() => import('../assets/svgs/package.svg'));
const People = dynamic(() => import('../assets/svgs/people.svg'));
const Permission = dynamic(() => import('../assets/svgs/permission.svg'));
const PersonalStatement = dynamic(
  () => import('../assets/svgs/personal-statement.svg'),
);
const PlusBook = dynamic(() => import('../assets/svgs/plus-book.svg'));
const PlusJourney = dynamic(() => import('../assets/svgs/plus-journey.svg'));
const PlusQuestion = dynamic(() => import('../assets/svgs/plus-question.svg'));
const PoweredByStripe = dynamic(
  () => import('../assets/svgs/powered-by-stripe.svg'),
);
const Presentations = dynamic(() => import('../assets/svgs/presentations.svg'));
const Pricing = dynamic(() => import('../assets/svgs/pricing.svg'));
const Profile = dynamic(() => import('../assets/svgs/profile.svg'));
const Promotion = dynamic(() => import('../assets/svgs/promotion.svg'));
const PromotionStrategy = dynamic(
  () => import('../assets/svgs/promotion-strategy.svg'),
);
const QuantitativeReasoning = dynamic(
  () => import('../assets/svgs/quantitative-reasoning.svg'),
);
const Ratings = dynamic(() => import('../assets/svgs/ratings.svg'));
const Reading = dynamic(() => import('../assets/svgs/reading.svg'));
const ReferralShare = dynamic(
  () => import('../assets/svgs/referral-share.svg'),
);
const ReferralFriend = dynamic(
  () => import('../assets/svgs/referral-friend.svg'),
);
const ReferralReceive = dynamic(
  () => import('../assets/svgs/referral-receive.svg'),
);
const ExclamationIllustration = dynamic(
  () => import('../assets/svgs/exclamation-illustration.svg'),
);
const Refund = dynamic(() => import('../assets/svgs/refund.svg'));
const Resume = dynamic(() => import('../assets/svgs/resume.svg'));
const ResumeReview = dynamic(() => import('../assets/svgs/resume-review.svg'));
const SalaryNegotiation = dynamic(
  () => import('../assets/svgs/salary-negotiation.svg'),
);
const Scholarships = dynamic(() => import('../assets/svgs/scholarship.svg'));
const School = dynamic(() => import('../assets/svgs/school.svg'));
const Science = dynamic(() => import('../assets/svgs/science.svg'));
const SearchUser = dynamic(() => import('../assets/svgs/search-user.svg'));
const Search = dynamic(() => import('../assets/svgs/search.svg'));
const SecondaryReview = dynamic(
  () => import('../assets/svgs/secondary-review.svg'),
);
const Services = dynamic(() => import('../assets/svgs/services.svg'));
const Settings = dynamic(() => import('../assets/svgs/settings.svg'));
const Shield = dynamic(() => import('../assets/svgs/shield.svg'));
const SignOut = dynamic(() => import('../assets/svgs/sign-out.svg'));
const Slack = dynamic(() => import('../assets/svgs/slack.svg'));
const Sort = dynamic(() => import('../assets/svgs/sort.svg'));
const Sourcing = dynamic(() => import('../assets/svgs/sourcing.svg'));
const Sparkle = dynamic(() => import('../assets/svgs/sparkle.svg'));
const SpecializationStrategy = dynamic(
  () => import('../assets/svgs/specialization-strategy.svg'),
);
const Star = dynamic(() => import('../assets/svgs/star.svg'));
const StrategyAndVision = dynamic(
  () => import('../assets/svgs/strategy-and-vision.svg'),
);
const Success = dynamic(() => import('../assets/svgs/success.svg'));
const SuccessCircle = dynamic(
  () => import('../assets/svgs/success-circle.svg'),
);
const Switch = dynamic(() => import('../assets/svgs/switch.svg'));
const SwitchToClient = dynamic(
  () => import('../assets/svgs/switch-to-client.svg'),
);
const Test = dynamic(() => import('../assets/svgs/test.svg'));
const Tiktok = dynamic(() => import('../assets/svgs/tiktok.svg'));
const TransferAdmissions = dynamic(
  () => import('../assets/svgs/transfer-admissions.svg'),
);
const Twitter = dynamic(() => import('../assets/svgs/twitter.svg'));
const UnionPay = dynamic(() => import('../assets/svgs/union-pay.svg'));
const User = dynamic(() => import('../assets/svgs/user.svg'));
const VerbalReasoning = dynamic(
  () => import('../assets/svgs/verbal-reasoning.svg'),
);
const Visa = dynamic(() => import('../assets/svgs/visa.svg'));
const VouchGraphic = dynamic(() => import('../assets/svgs/Vouch-Graphic.svg'));
const Waitlist = dynamic(() => import('../assets/svgs/waitlist.svg'));
const WarningCircle = dynamic(
  () => import('../assets/svgs/warning-circle.svg'),
);
const WorkingWithHeadhunters = dynamic(
  () => import('../assets/svgs/working-with-headhunters.svg'),
);
const Writing = dynamic(() => import('../assets/svgs/writing.svg'));
const X = dynamic(() => import('../assets/svgs/x.svg'));

export enum Svg {
  ACHIEVEMENTS = 'ACHIEVEMENTS',
  AMEX = 'AMEX',
  APPLE_ICON = 'APPLE_ICON',
  APPLICANTS = 'APPLICANTS',
  APPLICATION = 'APPLICATION',
  APPLICATION_EDIT = 'APPLICATION_EDIT',
  APPLY_SUCCCESS = 'APPLY_SUCCCESS',
  ARROW = 'ARROW',
  ARROW_RIGHT = 'ARROW_RIGHT',
  BADGE = 'BADGE',
  BELL = 'BELL',
  BRAINSTORMING = 'BRAINSTORMING',
  CALENDAR = 'CALENDAR',
  CASPER_TEST = 'CASPER_TEST',
  CERTIFICATE_CHECKMARK = 'CERTIFICATE_CHECKMARK',
  CHAT = 'CHAT',
  CHAT_ILLUSTRATION = 'CHAT_ILLUSTRATION',
  CHECK = 'CHECK',
  CHECK_CIRCLE = 'CHECK_CIRCLE',
  CHECK_CIRCLE_GREEN = 'CHECK_CIRCLE_GREEN',
  CHEVRON = 'CHEVRON',
  CHEVRON_BACK = 'CHEVRON_BACK',
  CHEVRON_DOUBLE = 'CHEVRON_DOUBLE',
  CLOCK = 'CLOCK',
  CLOCK_ALT = 'CLOCK_ALT',
  COPY = 'COPY',
  CREDIT = 'CREDIT',
  CUSTOM_PACKAGE = 'CUSTOM_PACKAGE',
  DASHBOARD = 'DASHBOARD',
  DEAL_EXECUTION = 'DEAL_EXECUTION',
  DINERS = 'DINERS',
  DING = 'DING',
  DISCOVER = 'DISCOVER',
  DUE_DILIGENCE = 'DUE_DILIGENCE',
  EARTH = 'EARTH',
  EDITING = 'EDITING',
  EMAIL = 'EMAIL',
  EMPLOYEE_BADGE = 'EMPLOYEE_BADGE',
  ENGLISH = 'ENGLISH',
  ERROR = 'ERROR',
  ERROR_CIRCLE = 'ERROR_CIRCLE',
  ESSAY = 'ESSAY',
  EXCLAMATION_ILLUSTRATION = 'EXCLAMATION_ILLUSTRATION',
  EXECUTION = 'EXECUTION',
  EXPAND = 'EXPAND',
  EXPERIENCES = 'EXPERIENCES',
  FACEBOOK = 'FACEBOOK',
  FILTER = 'FILTER',
  FINANCIAL_MODELING = 'FINANCIAL_MODELING',
  FRAMEWORKS = 'FRAMEWORKS',
  GIFT = 'GIFT',
  GLOBE = 'GLOBE',
  GMAT = 'GMAT',
  GOOGLE = 'GOOGLE',
  GRADUATE_HAT = 'GRADUATE_HAT',
  GRE = 'GRE',
  GROUP_CLASSES = 'GROUP_CLASSES',
  HAMBURGER = 'HAMBURGER',
  HELP = 'HELP',
  IMAGE = 'IMAGE',
  INBOX = 'INBOX',
  INFLUENCE_AND_COLLABORATION = 'INFLUENCE_AND_COLLABORATION',
  INFO_CIRCLE = 'INFO_CIRCLE',
  INFO_FILLED = 'INFO_FILLED',
  INSTAGRAM = 'INSTAGRAM',
  INTEGRATED_REASONING = 'INTEGRATED_REASONING',
  INTERVIEW = 'INTERVIEW',
  JCB = 'JCB',
  LELAND = 'LELAND',
  LELAND_COMPASS = 'LELAND_COMPASS',
  LELAND_LOGO = 'LELAND_LOGO',
  LETTERS_OF_EVALUATION = 'LETTERS_OF_EVALUATION',
  LIGHTNING = 'LIGHTNING',
  LINK = 'LINK',
  LINK_EXTERNAL = 'LINK_EXTERNAL',
  LINKEDIN = 'LINKEDIN',
  LINKEDIN_REVIEW = 'LINKEDIN_REVIEW',
  LINKEDIN_SQUARE = 'LINKEDIN_SQUARE',
  LOADER = 'LOADER',
  LOCATION = 'LOCATION',
  LOCK = 'LOCK',
  MASTERCARD = 'MASTERCARD',
  MATH = 'MATH',
  MD_PHD_ESSAY = 'MD_PHD_ESSAY',
  MENU = 'MENU',
  MESSAGE = 'MESSAGE',
  MESSAGE_ALT = 'MESSAGE_ALT',
  MESSAGE_UNREAD = 'MESSAGE_UNREAD',
  NETWORKING = 'NETWORKING',
  NOTIFICATIONS = 'NOTIFICATIONS',
  PACKAGE = 'PACKAGE',
  PEOPLE = 'PEOPLE',
  PERMISSON = 'PERMISSION',
  PERSONAL_STATEMENT = 'PERSONAL_STATEMENT',
  PLUS_BOOK = 'PLUS_BOOK',
  PLUS_JOURNEY = 'PLUS_JOURNEY',
  PLUS_QUESTION = 'PLUS_QUESTION',
  POWERED_BY_STRIPE = 'POWERED_BY_STRIPE',
  PRESENTATIONS = 'PRESENTATIONS',
  PRICING = 'PRICING',
  PROFILE = 'PROFILE',
  PROMOTION = 'PROMOTION',
  PROMOTION_STRATEGY = 'PROMOTION_STRATEGY',
  QUANTITATIVE_REASONING = 'QUANTITATIVE_REASONING',
  QUESTION_ILLUSTRATION = 'QUESTION_ILLUSTRATION',
  RATINGS = 'RATINGS',
  READING = 'READING',
  REFERRAL_FRIEND = 'REFERRAL_FRIEND',
  REFERRAL_RECEIVE = 'REFERRAL_RECEIVE',
  REFERRAL_SHARE = 'REFERRAL_SHARE',
  REFUND = 'REFUND',
  RESUME = 'RESUME',
  RESUME_REVIEW = 'RESUME_REVIEW',
  SALARY_NEGOTIATION = 'SALARY_NEGOTIATION',
  SCHOLARSHIPS = 'SCHOLARSHIPS',
  SCHOOL = 'SCHOOL',
  SCIENCE = 'SCIENCE',
  SEARCH_USER = 'SEARCH_USER',
  SEARCH = 'SEARCH',
  SECONDARY_REVIEW = 'SECONDARY_REVIEW',
  SERVICES = 'SERVICES',
  SETTINGS = 'SETTINGS',
  SHIELD = 'SHIELD',
  SIGN_OUT = 'SIGN_OUT',
  SLACK = 'SLACK',
  SORT = 'SORT',
  SOURCING = 'SOURCING',
  SPARKLE = 'SPARKLE',
  SPECIALIZATION_STRATEGY = 'SPECIALIZATION_STRATEGY',
  STAR = 'STAR',
  STRATEGY_AND_VISION = 'STRATEGY_AND_VISION',
  SUCCESS = 'SUCCESS',
  SUCCESS_CIRCLE = 'SUCCESS_CIRCLE',
  SWITCH = 'SWITCH',
  SWITCH_TO_CLIENT = 'SWITCH_TO_CLIENT',
  TEST = 'TEST',
  TIKTOK = 'TIKTOK',
  TRANSFER_ADMISSIONS = 'TRANSFER_ADMISSIONS',
  TWITTER = 'TWITTER',
  UNION_PAY = 'UNIONPAY',
  USER = 'USER',
  VERBAL_REASONING = 'VERBAL_REASONING',
  VISA = 'VISA',
  VOUCH_GRAPHIC = 'VOUCH_GRAPIC',
  WAITLIST = 'WAITLIST',
  WARNING_CIRCLE = 'WARNING_CIRCLE',
  WORKING_WITH_HEADHUNTERS = 'WORKING_WITH_HEADHUNTERS',
  WRITING = 'WRITING',
  X = 'X',
}

const SVG_STRING: Record<Svg, ComponentType> = Object.freeze({
  [Svg.ACHIEVEMENTS]: Achievements,
  [Svg.AMEX]: Amex,
  [Svg.APPLE_ICON]: AppleIcon,
  [Svg.APPLICANTS]: Applicants,
  [Svg.APPLICATION_EDIT]: ApplicationEdit,
  [Svg.APPLICATION]: Application,
  [Svg.APPLY_SUCCCESS]: ApplySuccess,
  [Svg.ARROW]: Arrow,
  [Svg.ARROW_RIGHT]: ArrowRight,
  [Svg.BADGE]: Badge,
  [Svg.BELL]: Bell,
  [Svg.BRAINSTORMING]: Brainstorming,
  [Svg.CALENDAR]: Calendar,
  [Svg.CASPER_TEST]: CasperTest,
  [Svg.CERTIFICATE_CHECKMARK]: CertificateCheckmark,
  [Svg.CHAT]: Chat,
  [Svg.CHAT_ILLUSTRATION]: ChatIllustration,
  [Svg.CHECK_CIRCLE]: CheckCircle,
  [Svg.CHECK_CIRCLE_GREEN]: CheckCircleGreen,
  [Svg.CHECK]: Check,
  [Svg.CHEVRON]: Chevron,
  [Svg.CHEVRON_BACK]: ChevronBack,
  [Svg.CHEVRON_DOUBLE]: ChevronDouble,
  [Svg.CLOCK_ALT]: ClockAlt,
  [Svg.CLOCK]: Clock,
  [Svg.COPY]: Copy,
  [Svg.CREDIT]: Credit,
  [Svg.CUSTOM_PACKAGE]: CustomPackage,
  [Svg.DASHBOARD]: Dashboard,
  [Svg.DEAL_EXECUTION]: DealExecution,
  [Svg.DINERS]: Diners,
  [Svg.DING]: Ding,
  [Svg.DISCOVER]: Discover,
  [Svg.DUE_DILIGENCE]: DueDiligence,
  [Svg.EARTH]: Earth,
  [Svg.EDITING]: Editing,
  [Svg.EMAIL]: Email,
  [Svg.EMPLOYEE_BADGE]: EmployeeBadge,
  [Svg.ENGLISH]: English,
  [Svg.ERROR_CIRCLE]: ErrorCircle,
  [Svg.ERROR]: ErrorIcon,
  [Svg.ESSAY]: Essay,
  [Svg.EXCLAMATION_ILLUSTRATION]: ExclamationIllustration,
  [Svg.EXECUTION]: Execution,
  [Svg.EXPAND]: Expand,
  [Svg.EXPERIENCES]: Experiences,
  [Svg.FACEBOOK]: Facebook,
  [Svg.FILTER]: Filter,
  [Svg.FINANCIAL_MODELING]: FinancialModeling,
  [Svg.FRAMEWORKS]: Frameworks,
  [Svg.GIFT]: Gift,
  [Svg.GLOBE]: Globe,
  [Svg.GMAT]: Gmat,
  [Svg.GOOGLE]: Google,
  [Svg.GRADUATE_HAT]: GraduateHat,
  [Svg.GRE]: Gre,
  [Svg.GROUP_CLASSES]: GroupClasses,
  [Svg.HAMBURGER]: Hamburger,
  [Svg.HELP]: Help,
  [Svg.IMAGE]: Image,
  [Svg.INBOX]: Inbox,
  [Svg.INFLUENCE_AND_COLLABORATION]: InfluenceAndCollaboration,
  [Svg.INFO_CIRCLE]: InfoCircle,
  [Svg.INFO_FILLED]: InfoFilled,
  [Svg.INSTAGRAM]: Instagram,
  [Svg.INTEGRATED_REASONING]: IntegratedReasoning,
  [Svg.INTERVIEW]: Interview,
  [Svg.JCB]: JCB,
  [Svg.LELAND_COMPASS]: LelandCompass,
  [Svg.LELAND_LOGO]: LelandLogo,
  [Svg.LELAND]: Leland,
  [Svg.LETTERS_OF_EVALUATION]: LettersOfEvaluation,
  [Svg.LIGHTNING]: Lightning,
  [Svg.LINK]: Link,
  [Svg.LINK_EXTERNAL]: LinkExternal,
  [Svg.LINKEDIN_REVIEW]: LinkedInReview,
  [Svg.LINKEDIN_SQUARE]: LinkedInSquare,
  [Svg.LINKEDIN]: LinkedIn,
  [Svg.LOADER]: Loader,
  [Svg.LOCATION]: Location,
  [Svg.LOCK]: Lock,
  [Svg.MASTERCARD]: MasterCard,
  [Svg.MATH]: Math,
  [Svg.MD_PHD_ESSAY]: MdPhDEssay,
  [Svg.MENU]: Menu,
  [Svg.MESSAGE]: Message,
  [Svg.MESSAGE_ALT]: MessageAlt,
  [Svg.MESSAGE_UNREAD]: MessageUnread,
  [Svg.NETWORKING]: Networking,
  [Svg.NOTIFICATIONS]: Notifications,
  [Svg.PACKAGE]: Package,
  [Svg.PEOPLE]: People,
  [Svg.PERMISSON]: Permission,
  [Svg.PERSONAL_STATEMENT]: PersonalStatement,
  [Svg.PLUS_BOOK]: PlusBook,
  [Svg.PLUS_JOURNEY]: PlusJourney,
  [Svg.PLUS_QUESTION]: PlusQuestion,
  [Svg.POWERED_BY_STRIPE]: PoweredByStripe,
  [Svg.PRESENTATIONS]: Presentations,
  [Svg.PRICING]: Pricing,
  [Svg.PROFILE]: Profile,
  [Svg.PROMOTION_STRATEGY]: PromotionStrategy,
  [Svg.PROMOTION]: Promotion,
  [Svg.QUANTITATIVE_REASONING]: QuantitativeReasoning,
  [Svg.QUESTION_ILLUSTRATION]: QuestionIllustration,
  [Svg.RATINGS]: Ratings,
  [Svg.READING]: Reading,
  [Svg.REFERRAL_FRIEND]: ReferralFriend,
  [Svg.REFERRAL_RECEIVE]: ReferralReceive,
  [Svg.REFERRAL_SHARE]: ReferralShare,
  [Svg.REFUND]: Refund,
  [Svg.RESUME_REVIEW]: ResumeReview,
  [Svg.RESUME]: Resume,
  [Svg.SALARY_NEGOTIATION]: SalaryNegotiation,
  [Svg.SCHOLARSHIPS]: Scholarships,
  [Svg.SCHOOL]: School,
  [Svg.SCIENCE]: Science,
  [Svg.SEARCH_USER]: SearchUser,
  [Svg.SEARCH]: Search,
  [Svg.SECONDARY_REVIEW]: SecondaryReview,
  [Svg.SERVICES]: Services,
  [Svg.SETTINGS]: Settings,
  [Svg.SHIELD]: Shield,
  [Svg.SIGN_OUT]: SignOut,
  [Svg.SLACK]: Slack,
  [Svg.SORT]: Sort,
  [Svg.SOURCING]: Sourcing,
  [Svg.SPARKLE]: Sparkle,
  [Svg.SPECIALIZATION_STRATEGY]: SpecializationStrategy,
  [Svg.STAR]: Star,
  [Svg.STRATEGY_AND_VISION]: StrategyAndVision,
  [Svg.SUCCESS_CIRCLE]: SuccessCircle,
  [Svg.SUCCESS]: Success,
  [Svg.SWITCH_TO_CLIENT]: SwitchToClient,
  [Svg.SWITCH]: Switch,
  [Svg.TEST]: Test,
  [Svg.TIKTOK]: Tiktok,
  [Svg.TRANSFER_ADMISSIONS]: TransferAdmissions,
  [Svg.TWITTER]: Twitter,
  [Svg.UNION_PAY]: UnionPay,
  [Svg.USER]: User,
  [Svg.VERBAL_REASONING]: VerbalReasoning,
  [Svg.VISA]: Visa,
  [Svg.VOUCH_GRAPHIC]: VouchGraphic,
  [Svg.WAITLIST]: Waitlist,
  [Svg.WARNING_CIRCLE]: WarningCircle,
  [Svg.WORKING_WITH_HEADHUNTERS]: WorkingWithHeadhunters,
  [Svg.WRITING]: Writing,
  [Svg.X]: X,
});

interface Props extends HTMLProps<HTMLElement> {
  svgType: Svg;
}

type CardBrandSvgType = Record<CardBrand, Svg>;

export const CARD_BRAND_SVGS: CardBrandSvgType = Object.freeze({
  [CardBrand.AMEX]: Svg.AMEX,
  [CardBrand.DINERS]: Svg.DINERS,
  [CardBrand.DISCOVER]: Svg.DISCOVER,
  [CardBrand.JCB]: Svg.JCB,
  [CardBrand.MASTERCARD]: Svg.MASTERCARD,
  [CardBrand.UNION_PAY]: Svg.UNION_PAY,
  [CardBrand.VISA]: Svg.VISA,
  [CardBrand.UNKNOWN]: Svg.CREDIT,
});

const SvgIcon: React.FC<Props> = ({ svgType, ...props }) => {
  const SVGComponent = SVG_STRING[svgType];

  if (!SVGComponent) {
    console.error('Svg type is not supported');
    return null;
  }

  return <SVGComponent {...props} />;
};

export default SvgIcon;
